module.exports = __webpack_public_path__ + "static/CLIENT SERVICE AGREEMENT_CA-175a42c2bdcc7347bc160857bf1180c7.pdf";